import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'
import { usePageSEO } from '@/hooks/usePageSEO'
import HomeExperience from '@/components/homePage/HomeExperience'

// Enable this for debugging only
const DEBUG = false

export const Route = createFileRoute('/')({
  component: HomeRoute,
  beforeLoad: async () => {
    return {}
  },
})

function HomeRoute() {
  usePageSEO({
    title: 'JeridSchool - Plateforme de gestion scolaire en Tunisie',
    description:
      'JeridSchool centralise la vie scolaire en Tunisie : emplois du temps, presences, examens, communication parents-ecole et outils IA pour les etablissements prives.',
    keywords:
      'gestion scolaire Tunisie, logiciel ecole privee, plateforme scolaire, emploi du temps automatique, communication parents ecole',
    path: '/',
  })

  // Add debugging to help troubleshoot
  useEffect(() => {
    if (!DEBUG) return // Skip debug logging if not needed

    const hostname = window.location.hostname
    const isSubdomain =
      hostname.includes('.localhost') || hostname.includes('.jeridschool.com')
// console.logHomeRoute rendered with hostname:', hostname)
// console.logIs subdomain (client-side check):', isSubdomain)

    if (isSubdomain) {
      // const schoolName = hostname.split('.')[0]
  // console.logSchool name from subdomain (client-side):', schoolName)
    }
  }, [])

  return (
    <HomeExperience />
  )
}
